/**
 * Detects the user's timezone using the browser's Intl API.
 *
 * This function uses the Intl.DateTimeFormat API to retrieve the user's
 * timezone as an IANA timezone string (e.g., "America/New_York", "Europe/London").
 *
 * @returns IANA timezone string if detection succeeds, null if detection fails
 *
 * @example
 * const timezone = detectTimezone();
 * if (timezone) {
 *   console.log(`User timezone: ${timezone}`); // "America/New_York"
 * } else {
 *   console.log('Timezone detection not supported');
 * }
 */
export function detectTimezone(): string | null {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timezone || null;
  } catch (error) {
    console.warn('Timezone detection failed:', error);
    return null;
  }
}
